module.exports = __webpack_public_path__ + "static/media/card-print.118c3b52.svg";